import { HttpFailedRequestError } from "@core/domain/infrastructures/http/errors/http-failed-request.error";

export class HttpUnauthorizedError extends HttpFailedRequestError {
    static readonly CODE = 401;

    constructor(errorCode?: number) {
        super(HttpUnauthorizedError.CODE, errorCode);

        Object.setPrototypeOf(this, HttpUnauthorizedError.prototype);
    }
}
